var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "hoverfill",
    cx: 25,
    cy: 25,
    r: 25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "content",
    d: "M35.059 18.0798C33.7565 17.8017 32.5771 17.1155 31.6926 16.1214C30.8081 15.1272 30.2649 13.8771 30.1421 12.5531V11.979H25.649V29.7788C25.6462 30.5668 25.3962 31.3341 24.934 31.973C24.4718 32.6118 23.8207 33.09 23.0722 33.3404C22.3237 33.5908 21.5154 33.6008 20.7609 33.369C20.0064 33.1372 19.3437 32.6752 18.8658 32.048C18.3804 31.4103 18.1112 30.6349 18.0971 29.8341C18.0831 29.0334 18.3249 28.249 18.7875 27.5947C19.2501 26.9404 19.9094 26.4502 20.67 26.1951C21.4305 25.9401 22.2526 25.9335 23.0171 26.1764V21.6197C21.3123 21.3844 19.5764 21.687 18.0524 22.485C16.5283 23.2831 15.2922 24.5367 14.5171 26.0705C13.7419 27.6044 13.4664 29.3417 13.7291 31.0395C13.9917 32.7374 14.7795 34.3108 15.9821 35.5397C17.129 36.7111 18.5995 37.5148 20.206 37.8482C21.8126 38.1816 23.4821 38.0295 25.0017 37.4114C26.5212 36.7933 27.8218 35.7373 28.7373 34.378C29.6529 33.0188 30.142 31.418 30.1421 29.7801V20.6849C31.9579 21.9807 34.135 22.6756 36.3671 22.6716V18.2152C35.9275 18.2157 35.4891 18.1703 35.059 18.0798Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.63a6e9d9c02fdf6693f74d8ed197315a.svg";
export { ForwardRef as ReactComponent };